import script from "./AddUpdateCourse.vue?vue&type=script&setup=true&lang=js"
export * from "./AddUpdateCourse.vue?vue&type=script&setup=true&lang=js"

import "./AddUpdateCourse.vue?vue&type=style&index=0&id=6d9ab0c4&scoped=true&lang=stylus"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d9ab0c4"]])

export default __exports__